import {
  funcScrollControl,
  funcLoad,
  topFirst,
} from './index';

const funcEntry = (() => {


  funcScrollControl.noScroll();


  if (document.querySelector("body#pageTop") !== null) {
    document.addEventListener("DOMContentLoaded", () => {
      funcLoad()
      topFirst()
    });
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      funcLoad()
    });
  }


})();
export default funcEntry;